<div class="accept-esign" *transloco="let t">
	<div *ngIf="esignEnabled">
		<op-masthead
			><b class="client-name">{{
				t('ESIGN_DISCLOSURE.accept_esign.title', { clientName: clientName })
			}}</b></op-masthead
		>
		<div *ngIf="applicantIndex === 0" class="op-mb-20" [innerHTML]="t('ESIGN_DISCLOSURE.accept_esign.opted')"></div>
		<div
			*ngIf="applicantIndex === 1"
			class="op-mb-20"
			[innerHTML]="t('ESIGN_DISCLOSURE.accept_esign.optedCoapp')"
		></div>
		<p>{{ t('ESIGN_DISCLOSURE.accept_esign.team') }}</p>
		<div mat-dialog-actions>
			<button class="confirm" mat-flat-button color="primary-small" (click)="onClick()">
				{{ 'GLOBAL.ok' | transloco }}
			</button>
		</div>
	</div>

	<div *ngIf="!esignEnabled">
		<div class="accept-esign" *transloco="let t">
			<op-masthead
				><b class="client-name">{{
					t('ESIGN_DISCLOSURE.accept_esign.title', { clientName: clientName })
				}}</b></op-masthead
			>
			<p class="op-mb-20">{{ t('ESIGN_DISCLOSURE.accept_esign.optedInitial') }}</p>
			<p>{{ t('ESIGN_DISCLOSURE.accept_esign.teamInitial') }}</p>
			<p>{{ t('ESIGN_DISCLOSURE.accept_esign.close') }}</p>
		</div>
	</div>
</div>
